export const AlliancesList = [
  <div
    key="alliance-1"
    className="grid grid-cos-1 gap-y-10 gap-x-10 place-content-center justify-center items-center m-auto sm:grid-cols-2 md:grid-cols-3 w-full text-3xl text-white"
  >
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/axis.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/yesbank.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/lic.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/hdfc.png"
    />

    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/pnb.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/unity.png"
    />
  </div>,
  <div
    key="alliance-2"
    className="grid grid-cos-1 gap-y-10 gap-x-10 place-content-center justify-center items-center m-auto sm:grid-cols-2 md:grid-cols-3 w-full text-3xl text-white"
  >
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/csb.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/icici.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/repco.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/canarabank.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/reliance.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/maximus.png"
    />
  </div>,
  <div
    key="alliance-3"
    className="grid grid-cos-1 gap-y-10 gap-x-10 place-content-center justify-center items-center m-auto sm:grid-cols-2 md:grid-cols-3 w-full text-3xl text-white"
  >
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/cent.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/navbharat.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/southindianbank.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/muthoothf.png"
    />
    <img
      alt=""
      className="h-20 md:h-24 md:w-full w-72"
      src="/alliances/fi1.png"
    />
  </div>,
];

export const CollaborationList = [
  <div
    key="collaborator-1"
    className="grid grid-cos-1 gap-y-10 gap-x-10 place-content-center justify-center items-center m-auto w-full text-3xl text-white"
  >
    <img
      src="/alliances/nobroker.png"
      className="h-20 md:h-24 w-72 md:w-full flex m-auto"
    />
    {/* <img
      src="/alliances/smartbuy.png"
      className="h-20 md:h-24 w-72 md:w-1/2 flex m-auto"
    /> */}
  </div>,
];
